<script lang="ts">
  import FooterLogo from "./FooterLogo.svelte";

  const year = new Date().getFullYear();
  const version = `v${import.meta.env.VERSION}`;

  const links = [
    ["Discord", "https://opr.as/footer-discord"],
    ["Twitter", "https://opr.as/footer-twitter"],
    ["Twitch", "https://opr.as/footer-twitch"],
    ["Reddit", "https://opr.as/footer-reddit"],
    ["Forum", "https://opr.as/footer-forum"],
    ["Blog", "https://opr.as/footer-blog"],
    ["Contact us", "https://www.opera.com/contact"],
  ];
</script>

<footer class="border-t-neutral-32 mt-12 flex flex-col items-center border-t">
  <div class="p-8">
    <FooterLogo />
  </div>
  <div class="footer__links px-8 pb-8 text-center text-sm uppercase">
    {#each links as [text, href]}
      <a class="inline-block p-1 no-underline" target="_blank" rel="noreferrer" {href}
        >{text}</a>
    {/each}
  </div>
  <div class="text-neutral-32 px-8 pb-8 text-xs">
    © 1995-{year} Opera Norway - All rights reserved.
  </div>
  <div class="text-neutral-32 self-end px-4 text-right text-xs">{version}</div>
</footer>
